(function ($) {
    $('.accordion .accordion__header:first-child').addClass('active');

    $('.accordion .accordion__header').on('click', function (e) {
        e.preventDefault();
        const thisAccordion = $(this).parent().parent();
        if ($(this).hasClass('active')) {
            $(this).next('div.accordion__panel').removeClass('active').slideToggle('200');
            $(this).removeClass('active');
        } else {
            $(this).next('div.accordion__panel').addClass('active').slideToggle('200').siblings('div.accordion__panel:visible').removeClass('active').slideToggle('200');
            $(thisAccordion).find('.accordion__header').removeClass('active');
            $(this).addClass('active');
        }

        return false;
    });
})(jQuery);
